import React from "react";
import frontImg from "../../assets/images/front-end.png";
import designImg from "../../assets/images/design.png";
import {
  SiAdobeillustrator,
  SiAdobephotoshop,
  SiFigma,
  SiPhp,
  SiTailwindcss,
  SiWebflow,
  SiWordpress,
} from "react-icons/si";
import { HiPaintBrush } from "react-icons/hi2";

const Service = () => {
  return (
    <section id="services">
      <div className="container lg:pt-5">
        <div className="text-center">
          <h2 className="text-headingColor font-[800] text-[2.4rem] mb-5">
            My Skills, Effort, and Time for your projects
          </h2>
          <p className="lg:max-w-[600px] lg:mx-auto text-headingColor font-[500] text-[16px] leading-7">
            My passion for design and technology goes back a long way, and I
            have experience as a Web Developer, Graphic Designer, and UI/UX
            Designer. I'm ready to help you achieve your goals with effective
            creative and technical solutions.
          </p>
        </div>
        <div className="flex flex-col justify-center sm:py-12">
          <div className="w-full py-3 px-2 sm:max-w-xl sm:mx-auto sm:px-0">
            <div className="relative text-gray-700 anitaliased text-sm font-semibold">
              {/* ===========vertical line runnign through the middle ========= */}
              <div className="hidden absolute w-1 sm:block bg-indigo-300 h-full left-1/2 transform -translate-x-1/2 rounded"></div>
              {/* ============left card=========== */}
              <div className="mt-6 sm:mt-0 sm:mb-12">
                <div className="flex items-center flex-col sm:flex-row">
                  <div className="flex justify-start w-full mx-auto items-center">
                    <div className="w-full sm:w-1/2 sm:pr-8">
                      <div
                        data-aos="fade-right"
                        data-aos-duration="1200"
                        className="bg-white p-4 rounded shadow group hover:bg-primaryColor cursor cursor-pointer ease-in duration-150"
                      >
                        <h3 className="text-primaryColor font-[700] mb-3 group-hover:text-white group-hover:font-[600] text-xl">
                          Web Developer
                        </h3>
                        <p className="text-[15px] text-smallTextColor group-hover:text-white group-hover:font-[500] leading-7">
                          I am a web developer who focuses on creating
                          interactive and engaging user experiences through
                          responsive, user-friendly, and high-performance
                          website design and development.
                        </p>
                        <div className="text-smallTextColor group-hover:text-white">
                          <h1 className="mt-5 mb-3 font-semibold">
                            My Skills :
                          </h1>
                          <div className="flex items-center gap-4 flex-wrap">
                            <p className="flex items-center gap-1">
                              <i className="ri-html5-fill"></i> HTML
                            </p>
                            <p className="flex items-center gap-1">
                              <i className="ri-css3-line"></i> CSS
                            </p>
                            <p className="flex items-center gap-1">
                              <i className="ri-javascript-line"></i> JavaScript
                            </p>
                            <p className="flex items-center gap-1">
                              <i className="ri-reactjs-fill"></i> React JS
                            </p>
                            <p className="flex items-center gap-1">
                              <i className="ri-vuejs-fill"></i> Vue JS
                            </p>
                            <p className="flex items-center gap-1">
                              <SiTailwindcss /> Tailwind CSS
                            </p>
                            <p className="flex items-center gap-1">
                              <SiPhp /> PHP Laravel
                            </p>
                            <p className="flex items-center gap-1">
                              <SiWebflow /> Webflow
                            </p>
                            <p className="flex items-center gap-1">
                              <SiWordpress /> WordPress
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-full bg-primaryColor border-white border-4 w-10 h-10 absolute left-1/2 transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center">
                    <figure>
                      <img src={frontImg} alt="" />
                    </figure>
                  </div>
                </div>
              </div>

              {/* ============right card=========== */}
              <div className="mt-6 sm:mt-0 sm:mb-12">
                <div className="flex items-center flex-col sm:flex-row">
                  <div className="flex justify-end w-full mx-auto items-center">
                    <div className="w-full sm:w-1/2 sm:pl-8">
                      <div
                        data-aos="fade-left"
                        data-aos-delay="100"
                        data-aos-duration="1400"
                        className="bg-white p-4 rounded shadow group hover:bg-primaryColor cursor cursor-pointer ease-in duration-150"
                      >
                        <h3 className="text-primaryColor font-[700] mb-3 group-hover:text-white group-hover:font-[600] text-xl">
                          UI/UX Designer & Graphic Designer
                        </h3>
                        <p className="text-[15px] text-smallTextColor group-hover:text-white group-hover:font-[500] leading-7">
                          I am a UI/UX Designer & Graphic Designer who is
                          dedicated to creating exceptional user experiences
                          through captivating design and the latest
                          technological innovations.
                        </p>
                        <div className="text-smallTextColor group-hover:text-white">
                          <span className="mt-5 flex items-center gap-3 flex-wrap">
                            <h1>My Skills :</h1>
                            <div className="flex items-center gap-1 flex-wrap">
                              <SiFigma />
                              <p>Figma</p>
                            </div>
                            <div className="flex items-center gap-1 flex-wrap">
                              <SiAdobephotoshop />
                              <p>Photoshop</p>
                            </div>
                            <div className="flex items-center gap-1 flex-wrap">
                              <SiAdobeillustrator />
                              <p>Illustrator</p>
                            </div>
                            <div className="flex items-center gap-1 flex-wrap">
                              <HiPaintBrush />
                              <p>Corel Draw</p>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="rounded-full bg-primaryColor border-white border-4 w-10 h-10 absolute left-1/2 transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center">
                    <figure>
                      <img src={designImg} alt="" />
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            {/* ============left card=========== */}
            {/* <div className="mt-6 sm:mt-0 sm:mb-12">
              <div className="flex items-center flex-col sm:flex-row">
                <div className="flex justify-start w-full mx-auto items-center">
                  <div className="w-full sm:w-1/2 sm:pr-8">
                    <div
                      data-aos="fade-right"
                      data-aos-duration="1200"
                      className="bg-white p-4 rounded shadow group hover:bg-primaryColor cursor-pointer ease-in duration-150"
                    >
                      <h3 className="text-primaryColor font-[700] mb-3 group-hover:text-white group-hover:font-[600] text-xl">
                        Video Editor
                      </h3>
                      <p className="text-[15px] text-smallTextColor group-hover:text-white group-hover:font-[500] leading-7">
                        I am a passionate video editor with expertise in
                        creating compelling and dynamic videos. I specialize in
                        crafting cinematic narratives, editing high-quality
                        footage, and enhancing visuals with advanced
                        post-production techniques.
                      </p>
                      <div className="text-smallTextColor group-hover:text-white">
                        <span className="mt-5 flex items-center gap-3 flex-wrap">
                          <h1>My Tools & Skills:</h1>
                          <p className="">
                            <i className="ri-video-line"></i> Adobe Premiere Pro
                          </p>
                          <p className="">
                            <i className="ri-film-line"></i> Capcut
                          </p>
                          <p className="">
                            <i className="ri-layers-line"></i> After Effects
                          </p>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="rounded-full bg-primaryColor border-white border-4 w-10 h-10 absolute left-1/2 transform -translate-x-1/2 -translate-y-4 sm:translate-y-0 flex items-center justify-center">
                  <figure>
                    <img src={frontImg} alt="Video Editor" />
                  </figure>
                </div>
              </div>
            </div> */}
            {/* ============left card=========== */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
